<section class="has-block-padding-sm animated fadeIn" >
  <h2 class="section-title">Frequently Asked Questions</h2>
</section>
<div ngbAccordion [closeOthers]="true">
  @for (item of faq; track item) {
    <div ngbAccordionItem [collapsed]="true">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>{{ item.question }}</button>
      </h2>
      <div ngbAccordionCollapse (click)="$event.stopPropagation()">
        <div ngbAccordionBody>
          <div [innerHTML]="sanitizeHtml(item.answer)">
          </div>
        </div>
      </div>
    </div>
  }
</div>
